import { Box, Typography } from "@mui/material";
import {  EventBusy, EventAvailable, CalendarToday, FindInPage } from "@mui/icons-material";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ReceiptSharpIcon from '@mui/icons-material/ReceiptSharp';
import SummarizeSharpIcon from '@mui/icons-material/SummarizeSharp';
import GppGoodIcon from '@mui/icons-material/GppGood';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruckFast } from "@fortawesome/free-solid-svg-icons";
import ListAltIcon from '@mui/icons-material/ListAlt';
import ShieldIcon from '@mui/icons-material/Shield';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ArchiveIcon from '@mui/icons-material/Archive';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import SvgIcon from '@mui/material/SvgIcon';
import { xlColq } from "../../common/constants";

const RedCircle = ({number}) => (
    <Box
      sx={{
        width: 24,
        height: 24,
        borderRadius: '50%',
        backgroundColor: '#ed4348',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0'
      }}
    >
      <Typography variant="body2" fontWeight="bold" color="#fff">
        {number}
      </Typography>
    </Box>  
  );
  const ShieldWithHeartIcon = () => {
  return (
    <Box sx={{ position: 'relative', width: 24, height: 24 }}>
      {/* Base Shield Icon */}
      <ShieldIcon
        sx={{
          fontSize: 32,
          color: '#5F6368', // optional styling
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      />
      {/* Heart Icon layered inside */}
      <FavoriteIcon
        sx={{
          fontSize: 16,
          color: '#FFFFFF',
          position: 'absolute',
          top: 8,
          left: 8,
        }}
      />
    </Box>
  );
};

const ArchiveWithBookmarkIcon = () => {
  return (
    <Box sx={{ position: 'relative', width: 32, height: 32 }}>
      {/* Base Archive Icon */}
      <ArchiveIcon
        sx={{
          fontSize: 32,
          color: '#5F6368', // brownish archive color
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      />

      {/* Box to hide arrow inside ArchiveIcon */}
      <Box
        sx={{
          width: 14,
          height: 6,
          backgroundColor: '#5F6368',
          position: 'absolute',
          top: 16,
          left: 10.5,
        }}
      />

      {/* Bookmark Icon */}
      <BookmarkIcon
        sx={{
          fontSize: 18,
          color: '#fff', // white or contrast color
          backgroundColor: '#5F6368',
          borderRadius: '4px',
          padding: '2px',
          position: 'absolute',
          top: 8,
          left: 7,
        }}
      />
    </Box>
  );
};


function BoxWithLinesIcon(props) {
  return (
     <SvgIcon {...props}>
      {/* Main rectangle */}
      <rect x="2" y="2" width="20" height="20" rx="2" ry="2" fill="#5F6368" />

      {/* Horizontal white lines */}
      <line x1="6" y1="8" x2="18" y2="8" stroke="white" strokeWidth="2" />
      <line x1="6" y1="12" x2="18" y2="12" stroke="white" strokeWidth="2" />
      <line x1="6" y1="16" x2="18" y2="16" stroke="white" strokeWidth="2" />

       {/* Larger circle in bottom-right corner */}
      <circle cx="19" cy="19" r="6" fill="#5F6368" stroke="white" strokeWidth="2" />

      {/* Three horizontal white dots inside the circle */}
      <circle cx="16.8" cy="19" r="0.6" fill="white" />
      <circle cx="19" cy="19" r="0.6" fill="white" />
      <circle cx="21.2" cy="19" r="0.6" fill="white" />
    </SvgIcon>
  );
}
export const statusOverview = [
    { label: "Booked LRs", key: 'TotalBookingNetAmt', type: 'info', icon: <CalendarToday sx={{ fontSize: 24, color: '#2c679d' }} />, handleClick:'handleBookedLrs' },
    { label: "Pending LRs", key: 'PendingLRs', type: 'error', icon: <EventBusy sx={{ fontSize: 24, color: '#ed4348' }} /> },
    { label: "Delivered LRs", key: 'TotalDeliveryNetAmount', type: 'success', icon: <EventAvailable sx={{ fontSize: 24, color: '#398d5d' }} /> },
    { label: "Pending Dispatch LRs", key: 'PendingDispatchLRs', type: 'error', icon: <EventBusy sx={{ fontSize: 24, color: '#ed4348' }} /> },
    { label: "Pending Receive LRs", key: 'PendingReceiveLRs', type: 'error', icon: <EventBusy sx={{ fontSize: 24, color: '#ed4348' }} /> },
    { label: "Pending Delivery LRs", key: 'PendingDeliveryLRs', type: 'error', icon: <EventBusy sx={{ fontSize: 24, color: '#ed4348' }} /> },
    { label: "7 Days Pending LRs", key: 'SevenDaysPendingLRs', type: 'error', icon: <RedCircle number={7} /> },
    { label: "30 Days Pending LRs", key: 'ThirtyDaysPendingLRs', type: 'error', icon: <RedCircle number={30} /> },
    { label: "Missing LR’s", key: 'TotalBookingLost', type: 'error', icon: <FindInPage sx={{ fontSize: 24, color: '#ed4348' }} /> }
]
export const bookingOverview = [
    { label: "Freight Charges", key: 'TotalBookingFreight', icon: <ArchiveWithBookmarkIcon  /> },
    { label: "Document Charges", key: 'TotalBookingDocChg', icon: <SummarizeSharpIcon style={{ fontSize: 24 }} /> },
    { label: "GST", key: 'TotalBookingGST', icon: <ReceiptSharpIcon style={{ fontSize: '24px' }}/> },
    { label: "Insurance", key: 'TotalBookingInsurance', icon: <ShieldWithHeartIcon /> },
    { label: "Other Charges", key: 'TotalBookingOtherChg', icon: <BoxWithLinesIcon style={{ fontSize: 24 }} /> },
    { label: "Total Amount", key: 'TotalBookingNetAmt', icon: <ListAltIcon style={{ fontSize: 24 }} /> },
]
export const deliveryOverview = [
    { label: "Freight Charges", key: 'TotalDeliveryFreight', icon: <ArchiveWithBookmarkIcon  /> },
    { label: "Delivery Charges", key: 'TotalDeliveryHomeDeliveryChg', icon: <FontAwesomeIcon icon={faTruckFast} style={{ fontSize: 24 }} /> },
    { label: "Total Amount", key: 'TotalDeliveryNetAmount', icon: <ListAltIcon style={{ fontSize: 24 }} /> },
]
export const branchMonthlyBooking = [
  { headerName: "Rank", key: "rank" },
  { headerName: "Branch Name", key: "BranchName" },
  { headerName: "Achieved Target", key: "Target", align: "right" }
];
export const partyMonthlyBooking = [
  { headerName: "SN", key: "rank" },
  { headerName: "Party Name", key: "name" },
  { headerName: "Business (LRs)", key: "business", align: "right" }
];
export const deliveredLrTable = [
  { headerName: "Payment Type", key: "PaymentType" },
  { headerName: "LR Count", key: "LRCount", align: "right" },
]

export const bookedLRs = `http://buscrs.com/ReportCargo/BookingSummaryReport?`
export const bookedLRParams = {
FromDate:0,
ToDate:0,
intBranchID:0
}

export const pendingLRs =`http://buscrs.com/ReportCargo/GetCargoNonMovedDetailsWeb?`
export const commonPendingLRParams = {
  FromDate:0,
  ToDate:0,
  intCompanyId:0,
  intBranchId:0,
  intUserID:0,
  intTimeNotMovedSince:0,
  AllowViewAllReport:1,
  IncludeDate:0,
  StatusCode:'',
  Status:'',
  SelectBranchName:'',
  intIsDays:1,
  intDaysOrHours:0,
  IsSummary:1,
  IsBranchSummary:1,
  FinYrID:0,
  IsTranDtWise:0,
  IsOnlyExpressParcel:2,
  ver:4
}

//Booking overview parameters

export const commonBkngDelOverviewUrl =`http://buscrs.com/ReportCargo/DailyBranchwiseCollectionReport2?`
export const commonBkngDelOverviewParams = {
  FromDate: 0,
  ToDate: 0,
  BranchId: 0,
  Summary: 1,
  BranchName: ''
}
export const analysisHeaders = [
  { name: 'SN', field: 'sn', headerSx: {} },
  { name: 'PARTY NAME', field: 'partyName', headerSx: {} },
]
export const branchHeaders = [
  { name: 'SN', field: 'sn', headerSx: {} },
  { name: 'BRANCH NAME', field: 'branchName', headerSx: {} },
]
export const userHeaders = [
  { name: 'SN', field: 'sn', headerSx: {} },
  { name: 'USER NAME', field: 'UserName', headerSx: {} },
  { name: 'BRANCH NAME', field: 'branchName', headerSx: {} },
]
export const overAllHeaders = [
  { name: 'SN', field: 'sn', headerSx: {} },
  { name: 'SENDER NAME', field: 'SenderName', headerSx: {} },
  { name: 'BRANCH NAME', field: 'branchName', headerSx: {} },
]
export const totalHeaders = [{ name: 'TOTAL', field: 'total',xlCol: xlColq, headerSx: {} }]
export const rangeList = [
  {
    name: '3 Months',
    value: 3,
  },
  {
    name: '6 Months',
    value: 6,
  },
  {
    name: '9 Months',
    value: 9,
  },
  {
    name: '1 Year',
    value: 12,
  },
]
export const viewTypeList = [{
  name: 'Party Wise',
  id: 1
},{
  name: 'Party City Wise',
  id: 2
},{
  name: "Party Branch Wise",
  id: 3
}]
export const transTypeList = [
  {
    name: 'Booking',
    value: 'B',
  },
  {
    name: 'Delivery',
    value: 'D',
  },
]
export const orderList = [
  {
    name: 'Ascending',
    id: 1,
  },
  {
    name: 'Descending',
    id: 2,
  },
]
  